import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_BOLSA_POVO } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { AtualizarContatoRequest, Types } from './types';

// ACTIONS
import { atualizarContatoSuccess, atualizarContatoFailure } from './action';

function* atualizarContatoRequest(request: ReducerAction) {
	const { payload }: { payload: AtualizarContatoRequest } = request;
	const response: ApiResponse = yield call(
		postApi,
		PATH_BOLSA_POVO,
		`bolsa-povo/${CHANNEL}/atualizar-contato`,
		payload,
	);

	if (response.status === 200) {
		yield put(atualizarContatoSuccess(response));
	} else if (response.error) {
		yield put(atualizarContatoFailure());
	}
}

export default all([
	takeLatest(Types.ATUALIZAR_CONTRATO_REQUEST, atualizarContatoRequest),
]);
